import React from 'react';

const FeedMessage = () => {
  return (
    <svg
      width="146"
      height="118"
      viewBox="0 0 146 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M71.9736 49.6206L63.7703 83.2692C63.4657 84.5171 63.41 85.8127 63.6063 87.082C63.8027 88.3514 64.2472 89.5696 64.9144 90.6672C65.5817 91.7647 66.4587 92.72 67.4953 93.4785C68.5319 94.2369 69.7078 94.7837 70.9558 95.0876L111.754 105.034C112.803 116.552 122.335 117.403 126.096 117.798C126.133 117.8 126.17 117.79 126.2 117.769C126.231 117.748 126.254 117.717 126.265 117.682C126.277 117.647 126.276 117.609 126.264 117.574C126.251 117.539 126.228 117.509 126.196 117.489C123.496 115.843 122.69 111.33 122.51 107.656L125.538 108.394C126.786 108.699 128.082 108.755 129.351 108.558C130.62 108.362 131.839 107.917 132.936 107.25C134.034 106.583 134.989 105.706 135.748 104.669C136.506 103.633 137.053 102.457 137.357 101.209L145.56 67.5602C145.864 66.3124 145.92 65.0168 145.724 63.7475C145.528 62.4781 145.083 61.2599 144.416 60.1624C143.749 59.0648 142.872 58.1095 141.835 57.351C140.798 56.5926 139.622 56.0457 138.375 55.7418L83.792 42.4351C82.5441 42.1305 81.2485 42.0748 79.9792 42.2711C78.7098 42.4674 77.4916 42.9119 76.394 43.5792C75.2965 44.2465 74.3412 45.1235 73.5827 46.1601C72.8243 47.1967 72.2775 48.3726 71.9736 49.6206Z"
        fill="#E9ECF0"
      />
      <path
        d="M94.944 9.25807L108.359 52.336C108.856 53.9335 109.035 55.6134 108.883 57.2798C108.732 58.9461 108.253 60.5663 107.475 62.0478C106.698 63.5292 105.635 64.8428 104.35 65.9137C103.064 66.9845 101.58 67.7914 99.9821 68.2885L47.7512 84.5528C47.3285 99.613 35.0054 101.499 30.1484 102.319C30.1002 102.325 30.0513 102.315 30.0093 102.291C29.9674 102.266 29.9349 102.228 29.917 102.183C29.8991 102.138 29.8968 102.088 29.9105 102.041C29.9242 101.995 29.9531 101.954 29.9926 101.925C33.369 99.5646 34.0485 93.6317 33.9826 88.84L30.1046 90.0475C28.5072 90.5454 26.8274 90.7236 25.1611 90.5721C23.4948 90.4205 21.8747 89.9422 20.3933 89.1643C18.912 88.3865 17.5984 87.3244 16.5276 86.0388C15.4568 84.7531 14.6498 83.2691 14.1527 81.6715L0.738185 38.5935C0.240252 36.9961 0.0619463 35.3162 0.213458 33.6498C0.36497 31.9834 0.843326 30.3632 1.6212 28.8818C2.39907 27.4003 3.46123 26.0867 4.74696 25.0158C6.03269 23.945 7.51681 23.138 9.11452 22.6409L78.9915 0.881739C80.5889 0.383807 82.2688 0.205501 83.9352 0.357013C85.6016 0.508525 87.2218 0.98688 88.7032 1.76475C90.1847 2.54263 91.4983 3.60478 92.5691 4.89051C93.64 6.17624 94.447 7.66036 94.944 9.25807Z"
        fill="#D1F1FF"
      />
      <rect
        opacity="0.5"
        x="20.9631"
        y="71.1445"
        width="80.2869"
        height="7.00742"
        rx="3.50371"
        transform="rotate(-17.9874 20.9631 71.1445)"
        fill="white"
      />
      <rect
        opacity="0.5"
        x="16.6375"
        y="57.8242"
        width="80.2869"
        height="7.00742"
        rx="3.50371"
        transform="rotate(-17.9874 16.6375 57.8242)"
        fill="white"
      />
      <rect
        opacity="0.8"
        x="12.3118"
        y="44.5"
        width="33.3666"
        height="7.00742"
        rx="3.50371"
        transform="rotate(-17.9874 12.3118 44.5)"
        fill="white"
      />
    </svg>
  );
};

export default FeedMessage;
